import { React, useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { InsideDrawerNav } from "./InsideDrawerNav";

import { Routes, servicesRoutes } from "consts/Routes-App";

import { useRecoilState, useRecoilValue } from "recoil";
import { activeDrawerService, miaServices } from "recoilState/GlobalState";

import styles from "./ListDrawer.module.scss";
import { ExpandLess, ExpandMore, HomeRounded } from "@mui/icons-material";
import { Link } from "react-router-dom";

import * as iconServicios from "assets/icons/servicios";

export default function ListDrawer({ setOpen }) {
    const [isDrawerOpen, setIsDrawerOpen] = useState({});

    const services = useRecoilValue(miaServices);
    const [activeService, setActiveService] = useRecoilState(activeDrawerService);

    const handleClick = () => {
        setOpen(false);
    };

    const handleServiceClick = (servicioCod) => {
        setIsDrawerOpen((prev) => {
            const isCurrentlyOpen = prev[servicioCod];
            const allClosed = {};
            Object.keys(prev).forEach((key) => { allClosed[key] = false; });
            return { ...allClosed, [servicioCod]: !isCurrentlyOpen };
        });
    };

    useEffect(() => {
        setIsDrawerOpen(services.filter((service) => (service.servicioAutorizado === "Y" && service.servicioEstado === "A")).map(() => false))
    }, [services]);

    useEffect(() => {
        if (!activeService) return;
        setIsDrawerOpen((prev) => {
            const allClosed = {};
            Object.keys(prev).forEach((key) => { allClosed[key] = false; });
            return { ...allClosed, [activeService]: true };
        });
        setActiveService(null);
    }, [activeService, setActiveService]);

    return (
        <>
            {services && (
                <List
                    aria-labelledby="nested-list-subheader"
                    className={styles.root}
                    component="nav"
                >
                    <Link to={Routes.dashboard.route}>
                        <ListItem
                            className={styles.itemList}
                            onClick={handleClick}
                        >
                            <ListItemIcon>
                                <HomeRounded className={styles.iconsDrawer} />
                            </ListItemIcon>
                            <span className={styles.textColor}>Home</span>
                        </ListItem>
                    </Link>

                    {services.map((service, index) => (
                        service.servicioAutorizado === "Y" && (
                            <span key={service.servicioCod}>
                                <ListItemButton
                                    className={styles.itemList}
                                    onClick={() => handleServiceClick(service.servicioCod)}
                                >
                                    <ListItemIcon>
                                        <img
                                            alt={service.servicioNombre}
                                            className={`${styles.iconsDrawer} ${isDrawerOpen[service.servicioCod] ? styles.iconsDrawerOpen : ""}`}
                                            src={iconServicios[service.servicioCod]}
                                        />
                                    </ListItemIcon>
                                    <ListItemText className={isDrawerOpen[service.servicioCod] ? styles.textColorSelect : styles.textColor}>
                                        {service.servicioNombre}
                                    </ListItemText>
                                    {isDrawerOpen[service.servicioCod] ? <ExpandLess className={styles.expandOpen} /> : <ExpandMore className={styles.expandClosed} />}
                                </ListItemButton>
                                <Collapse in={isDrawerOpen[service.servicioCod]} timeout="auto">
                                    <List component="div">
                                        {
                                            servicesRoutes[service.servicioCod]?.map((menu, index) => (
                                                <InsideDrawerNav
                                                    key={menu.route}
                                                    menu={menu}
                                                    className={styles.link}
                                                    handleClick={handleClick}
                                                    route={`servicio/${service.servicioCod}`}
                                                />
                                            ))
                                        }
                                    </List>
                                </Collapse>
                            </span>
                        )
                    ))}
                </List>
            )}
        </>
    );
}

ListDrawer.propTypes = {
    setOpen: PropTypes.func.isRequired,
};
